import { render, staticRenderFns } from "./MangoIntegration.vue?vue&type=template&id=e98e1fe8&scoped=true"
import script from "./MangoIntegration.vue?vue&type=script&lang=js"
export * from "./MangoIntegration.vue?vue&type=script&lang=js"
import style0 from "./MangoIntegration.vue?vue&type=style&index=0&id=e98e1fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98e1fe8",
  null
  
)

export default component.exports